// extracted by mini-css-extract-plugin
export default {"coverLink":"nO-z","contentBox":"oO-z","zapposPromoContainer":"pO-z","zapposPromoGroupContainer":"qO-z","promos":"rO-z","bottom":"sO-z","top":"tO-z","right":"uO-z","left":"vO-z"};